import { GlobalState } from '@leverege/ui-redux';
export default class StringAttributeValueSuggestor {
  constructor(type, opts = {}) {
    this.attribute = opts.attribute;
    this.delegate = opts.delegate?.search ? opts.delegate : opts.delegate ? opts.delegate.parent() : null;
    this.relationship = opts.relationship;
    this.objectType = opts.objectType;
  }
  async suggest(value) {
    if (!this.attribute.source || !this.delegate) {
      return null;
    }
    const fieldType = this?.attribute?.source?.fieldType || this.attribute?.source?.attribute?.searchType || 'string';
    const results = await GlobalState.dispatch(this.delegate.search({
      filter: {
        type: 'expression',
        value: `*${value}*`,
        field: this.attribute.source.field,
        kind: 'wildcard',
        ignoreCase: true
      },
      aggs: {
        options: {
          type: 'terms',
          field: this.attribute.source.field,
          fieldType,
          size: 15
        }
      },
      limit: 0,
      queryName: 'aggregation.StringAttributeValueSuggestor'
    }));
    const suggestions = results?.aggs?.options?.buckets?.map(b => b.key);
    if (suggestions && suggestions.length > 0) {
      if (suggestions.indexOf(value) > -1) {
        return suggestions;
      }

      // Append the typed value to the suggestion for easy pickin'!
      return suggestions;
    }
    return [];
  }
}